import { render, staticRenderFns } from "./SelectLoyaltyReward.vue?vue&type=template&id=35383003&scoped=true&"
import script from "./SelectLoyaltyReward.vue?vue&type=script&lang=ts&"
export * from "./SelectLoyaltyReward.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLoyaltyReward.vue?vue&type=style&index=0&id=35383003&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35383003",
  null
  
)

export default component.exports